import { UserRole } from "src/types/enum/user-role";
import { AdminProfile } from "src/types/responses/admin-profile";
import { OrganizationAdmin } from "src/types/responses/organization-admin";
import orgApiV4 from "../../../../api/clients/org-api-v4";
import { PaginatedData } from "../../../../types/responses/paginated-data";

class OrganizationAdminsApi {
  async fetchOrganizationAdminsList(
    page: number,
    perPage: number,
  ): Promise<PaginatedData<OrganizationAdmin>> {
    const { data } = await orgApiV4.get<PaginatedData<OrganizationAdmin>>(`/admins`, {
      params: {
        page,
        perPage,
      },
    });

    return data;
  }

  async removeAdminFromOrganization(organizationAdminToken: string): Promise<void> {
    const { data } = await orgApiV4.delete(`/admins/${organizationAdminToken}`);

    return data;
  }

  async inviteOrganizationAdmin(
    email: string,
    phoneNumber: string,
    role: UserRole,
  ): Promise<OrganizationAdmin> {
    const { data } = await orgApiV4.post<OrganizationAdmin>(`/admins`, {
      email,
      phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
      role,
    });

    return data;
  }

  async resendOrganizationAdminInvitation(organizationAdminToken: string): Promise<void> {
    await orgApiV4.post(`/admins/${organizationAdminToken}/resend-invitation`);
  }

  async updateOrganizationAdminPhoneNumber(
    organizationAdminToken: string,
    phoneNumber: string,
  ): Promise<OrganizationAdmin> {
    const { data } = await orgApiV4.patch<OrganizationAdmin>(`/admins/${organizationAdminToken}`, {
      phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
    });

    return data;
  }

  async updateOrganizationAdminRole(
    organizationAdminToken: string,
    role: UserRole,
  ): Promise<OrganizationAdmin> {
    const { data } = await orgApiV4.patch<OrganizationAdmin>(`/admins/${organizationAdminToken}/role`, {
      role,
    });

    return data;
  }

  async fetchAdminProfile(): Promise<AdminProfile> {
    const { data } = await orgApiV4.get<AdminProfile>(`/admins/profile`);

    return data;
  }
}

export const organizationAdminsApi = new OrganizationAdminsApi();
